import { createGlobalStyle } from 'styled-components';
import { colors } from './constants';
import { text } from './text';
import { link } from './link';
import fonts from '../assets/fonts';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'AvenirNext';
    src: url('${fonts.AvenirNextRegularWoff2}') format('woff2'),
         url('${fonts.AvenirNextRegularWoff}') format('woff');
    font-weight: 400;
  }

  @font-face {
    font-family: 'AvenirNext';
    src: url('${fonts.AvenirNextMediumWoff2}') format('woff2'),
         url('${fonts.AvenirNextMediumWoff}') format('woff');
    font-weight: 500;
  }

  @font-face {
    font-family: 'AvenirNext';
    src: url('${fonts.AvenirNextDemiBoldWoff2}') format('woff2'),
         url('${fonts.AvenirNextDemiBoldWoff}') format('woff');
    font-weight: 600;
  }

  @font-face {
    font-family: 'AvenirNext';
    src: url('${fonts.AvenirNextBoldWoff2}') format('woff2'),
         url('${fonts.AvenirNextBoldWoff}') format('woff');
    font-weight: 700;
  }

  // BEGIN CSS RESET
  // SOURCE: https://meyerweb.com/eric/tools/css/reset/

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font-family: inherit;
    vertical-align: baseline;
  }

  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after, q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  // END CSS RESET

  html {
    font-family: 'AvenirNext', sans-serif;
    /* [Style] Base font-size is 10px, meaning that 1rem is 10px. 1.6rem are 16px. */
    /*  Use rem to keep the site proportional when zooming with the browser */
    font-size: 10px;
  }

  body {
    color: ${colors.graphite};
    margin: 0;
    line-height: 1;
    background-color: ${colors.lightGrey};
    position: relative;
    overflow-x: hidden;
  }

  /* IE */
  div[role="group"][tabindex] {
    overflow: hidden;
  }

  p, span, a, button, input {
    ${text}
  }

  a {
    ${link}
  }

  input {
    font-family: 'AvenirNext', sans-serif;
  }

  button, input {
    font-family: 'AvenirNext', sans-serif;
    font-weight: 600;
  }

  address {
    font-style: normal;
  }
`;

export default GlobalStyle;
